import styled from "styled-components";
// import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`

.accordion-header{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 32px 12px 32px 24px;
        background: #FFFFFF;
        border-radius: 8px 8px 0px 0px;
        width:100%;
        cursor:pointer;
        .arrow.down{
            transform: rotate(180deg); 
        }
        .arrow.up{
            transform: rotate(0deg); 
        }


}
    .drivers-section{
        display: block;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
        border-radius: 0px 0px 12px 12px;
        width:100%;
        .driver-card{
            width:100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 12px 24px;
            background: #F2F3F5;
            border-radius: 8px;
            &.form_card{
                display: block;
            }
            form{
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                gap: 1rem;
                flex: 1 1 0;
                .field{
                    margin-bottom: .5rem;
                    flex: 1 1 0;

                }

            }
        }

        .add-driver{
            .pi-plus{
                background:transparent;
                color:white;
                font-weight:bold;
                margin: 0;
            }
        }
    }


    .actions{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 1rem;
        button{
          display: inline-flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 0px 24px;
          outline:none;
          box-shadow:none;
          border-radius: 5px;
          border:none;
          height: 42px;
          &.save-btn{
            background: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
            border-radius: 8px;
          }
          &.close-btn{
            border:none;
            color:#4C565C;
            margin:0 10px;
            &:hover,&:focus,&:active{
              background:transparent;
              border:none;
              color:#4C565C;
            }
          }
        }
      }
    }

    @media only screen and (max-width: 786px){
        .accordion-header{
            background:transparent;
        }
        .drivers-section{
            background:transparent;
            box-shadow: none;
            .driver-card{
                flex-direction: column;
                align-items: start;
                background: #fff;
            }
        }
    }
`;

export default StyleWrapper;
